export class PasswordChange{
    public currentPassword:string = "";
    public newPassword: string = "";
    public newPasswordConfirm: string = "";
    
    public reset(){
        this.currentPassword = ""
        this.newPassword = "";
        this.newPasswordConfirm = "";
    }
    
    public hasChanges(){
        return this.currentPassword !== "" ||
            this.newPassword !== "" ||
            this.newPasswordConfirm !== "";
    }
}
